import { render, staticRenderFns } from "./img-text-order.vue?vue&type=template&id=3f47ceca&scoped=true&"
import script from "./img-text-order.vue?vue&type=script&lang=js&"
export * from "./img-text-order.vue?vue&type=script&lang=js&"
import style0 from "./img-text-order.vue?vue&type=style&index=0&id=3f47ceca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47ceca",
  null
  
)

export default component.exports